import { useNavigate } from "react-router-dom";

/**
 * Shared logic for Settings functionality
 * Used by both mobile (full-screen) and desktop (modal) implementations
 */
export function useSettingsLogic() {
  const navigate = useNavigate();

  const handleCategoryClick = (category: string) => {
    navigate(`/settings/${category}`);
  };

  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return {
    handleCategoryClick,
    handleBackClick,
  };
}
